module.exports = __webpack_public_path__ + "static/media/arrow-right-disabled.8cca103a.svg";